/* eslint-disable @typescript-eslint/naming-convention */
import React, {useEffect} from 'react'
import ReportSubtitleV1 from 'components/Text/ReportSubtitleV1'
import ReportSubtitle from 'components/Text/ReportSubtitle'
import useLanguage from 'features/languageReport/useLanguage'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'
import {
  CommentTag,
  SectionTitle,
  CommentDivider,
  CommentContainer,
  CommentDiscussion,
} from 'components/molcules/N1SummaryReport/EEGChild/Style'

export default function EEGSummaryAlphaBandDevelopmentAPI(props: {
  alphaBandDevelopmentBarGraphImage: string | undefined
  alphaBandDevelopmentLineGraphImage: string | undefined
  ec_alpha_proportion_percentile: number
  eo_alpha_proportion_percentile: number
  isSummary?: boolean
}) {
  const {
    alphaBandDevelopmentBarGraphImage,
    alphaBandDevelopmentLineGraphImage,
    ec_alpha_proportion_percentile,
    eo_alpha_proportion_percentile,
    isSummary,
  } = props
  const classes = useStyles()
  const {textEegAPI, percentile} = useLanguage('eeg')

  const [discussionState, setDiscussionState] = React.useState<string>('')
  const [discussionTmpState, setDiscussionTmpState] = React.useState<string>('')

  useEffect(() => {
    const analysisComment =
      textEegAPI?.infant_youth.section.alpha_development.analysis_results
        .comments
    let discussion = ''
    let discussionTmp = ''
    if (
      ec_alpha_proportion_percentile != null &&
      eo_alpha_proportion_percentile != null
    ) {
      if (
        ec_alpha_proportion_percentile < percentile.low &&
        eo_alpha_proportion_percentile < percentile.low
      ) {
        discussion = analysisComment?.EC?.none?.EO?.low?.main ?? ''
        discussionTmp = analysisComment?.EC?.none?.EO?.low?.sub ?? ''
      } else if (
        ec_alpha_proportion_percentile < percentile.low &&
        eo_alpha_proportion_percentile > percentile.low &&
        eo_alpha_proportion_percentile <= percentile.high
      ) {
        discussion = analysisComment?.EC?.low?.EO?.normal?.main ?? ''
        discussionTmp = analysisComment?.EC?.low?.EO?.normal?.sub ?? ''
      } else if (
        ec_alpha_proportion_percentile < percentile.low &&
        eo_alpha_proportion_percentile > percentile.high
      ) {
        discussion = analysisComment?.EC?.low?.EO?.high?.main ?? ''
        discussionTmp = analysisComment?.EC?.low?.EO?.high?.sub ?? ''
      } else if (
        ec_alpha_proportion_percentile > percentile.low &&
        ec_alpha_proportion_percentile <= percentile.high &&
        eo_alpha_proportion_percentile < percentile.low
      ) {
        discussion = analysisComment?.EC?.normal?.EO?.low?.main ?? ''
        discussionTmp = analysisComment?.EC?.normal?.EO?.low?.sub ?? ''
      } else if (
        ec_alpha_proportion_percentile > percentile.low &&
        ec_alpha_proportion_percentile <= percentile.high &&
        eo_alpha_proportion_percentile > percentile.low &&
        eo_alpha_proportion_percentile <= percentile.high
      ) {
        discussion = analysisComment?.EC?.none?.EO?.normal?.main ?? ''
        discussionTmp = analysisComment?.EC?.none?.EO?.normal?.sub ?? ''
      } else if (
        ec_alpha_proportion_percentile > percentile.low &&
        ec_alpha_proportion_percentile <= percentile.high &&
        eo_alpha_proportion_percentile > percentile.high
      ) {
        discussion = analysisComment?.EC?.normal?.EO?.high?.main ?? ''
        discussionTmp = analysisComment?.EC?.normal?.EO?.high?.sub ?? ''
      } else if (
        ec_alpha_proportion_percentile > percentile.high &&
        eo_alpha_proportion_percentile < percentile.low
      ) {
        discussion = analysisComment?.EC?.high?.EO?.low?.main ?? ''
        discussionTmp = analysisComment?.EC?.high?.EO?.low?.sub ?? ''
      } else if (
        ec_alpha_proportion_percentile > percentile.high &&
        eo_alpha_proportion_percentile > percentile.low &&
        eo_alpha_proportion_percentile <= percentile.high
      ) {
        discussion = analysisComment?.EC?.high?.EO?.normal?.main ?? ''
        discussionTmp = analysisComment?.EC?.high?.EO?.normal?.main ?? ''
      } else if (
        ec_alpha_proportion_percentile > percentile.high &&
        eo_alpha_proportion_percentile > percentile.high
      ) {
        discussion = analysisComment?.EC?.high?.EO?.high?.main ?? ''
        discussionTmp = analysisComment?.EC?.high?.EO?.low?.sub ?? ''
      }
    } else if (
      ec_alpha_proportion_percentile != null &&
      eo_alpha_proportion_percentile == null
    ) {
      if (ec_alpha_proportion_percentile < percentile.low) {
        discussion = analysisComment?.EC?.low?.EO?.none?.main ?? ''
        discussionTmp = analysisComment?.EC?.low?.EO?.none?.sub ?? ''
      } else if (
        ec_alpha_proportion_percentile > percentile.low &&
        ec_alpha_proportion_percentile <= percentile.high
      ) {
        discussion = analysisComment?.EC?.normal?.EO?.none?.main ?? ''
        discussionTmp = analysisComment?.EC?.normal?.EO?.none?.sub ?? ''
      } else if (ec_alpha_proportion_percentile > percentile.high) {
        discussion = analysisComment?.EC?.high?.EO?.none?.main ?? ''
        discussionTmp = analysisComment?.EC?.high?.EO?.none?.sub ?? ''
      }
    } else if (
      ec_alpha_proportion_percentile == null &&
      eo_alpha_proportion_percentile != null
    ) {
      if (eo_alpha_proportion_percentile < percentile.low) {
        discussion = analysisComment?.EC?.low?.EO?.low?.main ?? ''
        discussionTmp = analysisComment?.EC?.low?.EO?.low?.sub ?? ''
      } else if (
        eo_alpha_proportion_percentile > percentile.low &&
        eo_alpha_proportion_percentile <= percentile.high
      ) {
        discussion = analysisComment?.EC?.normal?.EO?.none?.main ?? ''
        discussionTmp = analysisComment?.EC?.normal?.EO?.none?.sub ?? ''
      } else if (eo_alpha_proportion_percentile > percentile.high) {
        discussion = analysisComment?.EC?.none?.EO?.high?.main ?? ''
        discussionTmp = analysisComment?.EC?.none?.EO?.high?.sub ?? ''
      }
    }
    setDiscussionState(discussion)
    setDiscussionTmpState(discussionTmp)
  }, [textEegAPI])

  return (
    <div className={classes.eeg} style={{marginTop: 45}}>
      {isSummary ? (
        <ReportSubtitleV1 number='3'>
          {textEegAPI?.infant_youth.section.alpha_development.title}
        </ReportSubtitleV1>
      ) : (
        <ReportSubtitle number='3'>
          {textEegAPI?.infant_youth.section.alpha_development.title}
        </ReportSubtitle>
      )}

      <div className={classes.childValueGraphFull}>
        <div className='Child-info'>
          <SectionTitle className='Title'>
            {
              textEegAPI?.infant_youth.section.alpha_development.description
                .main
            }
          </SectionTitle>
          <div className='Desc' style={{color: '#333333'}}>
            {
              textEegAPI?.infant_youth.section.alpha_development.description
                .sub[0]
            }
            <br />
            {
              textEegAPI?.infant_youth.section.alpha_development.description
                .sub[1]
            }
          </div>
        </div>

        <div className='Child-Graph'>
          {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
          <img
            src={alphaBandDevelopmentLineGraphImage}
            alt='brain wave analysis 3d image'
          />
        </div>
        <div className='Child-Graph'>
          {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
          <img
            src={alphaBandDevelopmentBarGraphImage}
            alt='brain wave analysis 3d image'
          />
        </div>

        <div>
          <CommentTag>
            {
              textEegAPI?.infant_youth.section.alpha_development
                .analysis_results.title
            }
          </CommentTag>
          <CommentDivider />

          <CommentContainer>
            <CommentDiscussion>{discussionState}</CommentDiscussion>
            {'discussionTmp'.length > 0 && <div>{discussionTmpState}</div>}
          </CommentContainer>
        </div>
        <div className='Child-info-alert' style={{marginBottom: '45px'}}>
          {
            textEegAPI?.infant_youth.section.alpha_development.analysis_results
              .annotation
          }
        </div>
      </div>
    </div>
  )
}
